// src/components/orders/orderStatusBadge.js

import React from 'react';

const OrderStatusBadge = ({ status }) => {
  let bgColor, textColor, label;
  
  switch (status) {
    case 'PENDING':
      bgColor = 'bg-yellow-100';
      textColor = 'text-yellow-800';
      label = 'Pending';
      break;
    case 'PROCESSING':
      bgColor = 'bg-blue-100';
      textColor = 'text-blue-800';
      label = 'Processing';
      break;
    case 'SHIPPED':
      bgColor = 'bg-purple-100';
      textColor = 'text-purple-800';
      label = 'Shipped';
      break;
    case 'DELIVERED':
      bgColor = 'bg-green-100';
      textColor = 'text-green-800';
      label = 'Delivered';
      break;
    case 'CANCELLED':
      bgColor = 'bg-red-100';
      textColor = 'text-red-800';
      label = 'Cancelled';
      break;
    case 'PAYMENT_COMPLETED':
      bgColor = 'bg-green-100';
      textColor = 'text-green-800';
      label = 'Payment Completed';
      break;
    default:
      bgColor = 'bg-gray-100';
      textColor = 'text-gray-800';
      label = status || 'Unknown';
  }
  
  return (
    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-medium rounded-full ${bgColor} ${textColor}`}>
      {label}
    </span>
  );
};

export default OrderStatusBadge;